export { default as RealEstateSearch } from './RealEstateSearch';
